import {
  Sprite,
  Point,
  AnimatedSprite,
  Loader,
} from 'pixi.js';
import eventHub from '@/scripts/eventHub';
import audio from '@/scripts/audio';
import gsap from 'gsap/gsap-core';
import Actor from './Actor';
import vars from '../vars';

class PowerUpArea extends Actor {
  constructor(parent, renderer) {
    super(parent);

    this.ref = new Sprite();
    const blowAllLayerTextures = [
      ...Object.values(Loader.shared.resources['video/BLOW_ALL_1'].spritesheet.textures),
      ...Object.values(Loader.shared.resources['video/BLOW_ALL_2'].spritesheet.textures),
      ...Object.values(Loader.shared.resources['video/BLOW_ALL_3'].spritesheet.textures),
    ];
    this.blowAllLayer = new AnimatedSprite(blowAllLayerTextures);
    this.blowAllLayer.animationSpeed = 0.5;
    this.blowAllLayer.loop = false;
    this.blowAllLayer.stop();
    blowAllLayerTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    const powerLayerTextures = [
      ...Object.values(Loader.shared.resources['video/POWERUP_EFFECT_1'].spritesheet.textures),
      ...Object.values(Loader.shared.resources['video/POWERUP_EFFECT_2'].spritesheet.textures),
    ];
    this.powerLayer = new AnimatedSprite(powerLayerTextures);
    powerLayerTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.powerLayer.animationSpeed = 0.5;
    this.powerLayer.loop = false;
    this.powerLayer.stop();
    const powerPowerLayerTextures = Object.values(Loader.shared.resources['video/POWERUP_POWER'].spritesheet.textures);
    this.powerPowerLayer = new AnimatedSprite(powerPowerLayerTextures);
    powerPowerLayerTextures.forEach((t) => { renderer.plugins.prepare.upload(t); });
    this.powerPowerLayer.animationSpeed = 0.5;
    this.powerPowerLayer.stop();
    this.powerPowerLayer.renderable = false;
    this.ref.addChild(this.powerLayer);
    this.ref.addChild(this.powerPowerLayer);
    this.ref.addChild(this.blowAllLayer);

    this.resize();

    this.blowAllHandler = () => {
      setTimeout(() => {
        this.blowAllLayer.play();
        this.blowAllLayer.onComplete = () => { this.blowAllLayer.gotoAndStop(0); };
        audio.play('blowall');
      }, 500);
    };
    eventHub.$on('blow-all', this.blowAllHandler);
    this.rayPowerHandler = () => {
      this.powerLayer.play();
      this.powerLayer.onComplete = () => { this.powerLayer.gotoAndStop(0); };
      gsap.fromTo(this.powerPowerLayer, { alpha: 0 }, { alpha: 0.5, ease: 'power2.inOut', duration: 1 });
      this.powerPowerLayer.renderable = true;
      this.powerPowerLayer.loop = true;
      this.powerPowerLayer.play();
    };
    eventHub.$on('ray-power', this.rayPowerHandler);
    this.rayWideHandler = () => {
      this.powerLayer.play();
      this.powerLayer.onComplete = () => { this.powerLayer.gotoAndStop(0); };
    };
    eventHub.$on('ray-wide', this.rayWideHandler);
    this.rayFarHandler = () => {
      this.powerLayer.play();
      this.powerLayer.onComplete = () => { this.powerLayer.gotoAndStop(0); };
    };
    eventHub.$on('ray-far', this.rayFarHandler);
    this.stopPowerUpHandler = () => {
      gsap.to(this.powerPowerLayer, { alpha: 0, ease: 'power2.inOut', duration: 1 }).then(() => {
        this.powerPowerLayer.gotoAndStop(0);
        this.powerPowerLayer.renderable = false;
      });
    };
    eventHub.$on('stop-power-up', this.stopPowerUpHandler);

    this.parent.ref.addChild(this.ref);
  }

  resize() {
    this.blowAllLayer.anchor = new Point(0.5, 0.5);
    this.blowAllLayer.position.x = vars.layout.FRAME_WIDTH / 2;
    this.blowAllLayer.position.y = vars.layout.FRAME_HEIGHT / 2 - (vars.layout.FRAME_DIFFERENCE_TOP + vars.layout.FRAME_DIFFERENCE_BOTTOM);

    this.powerPowerLayer.anchor = new Point(0.5, 0.5);
    this.powerPowerLayer.position.x = vars.layout.FRAME_WIDTH / 2;
    this.powerPowerLayer.position.y = vars.layout.FRAME_HEIGHT / 2 - (vars.layout.FRAME_DIFFERENCE_TOP + vars.layout.FRAME_DIFFERENCE_BOTTOM) + 30;
  }

  destroy() {
    eventHub.$off('blow-all', this.blowAllHandler);
    eventHub.$off('ray-power', this.rayPowerHandler);
    eventHub.$off('ray-wide', this.rayWideHandler);
    eventHub.$off('ray-far', this.rayFarHandler);
    eventHub.$off('stop-power-up', this.stopPowerUpHandler);
    this.ref.destroy({ children: true });
  }
}

export default PowerUpArea;
